/* --------------------------------------------------------------------------
	Page
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import 'fastdom';
	import "../base/swap.js";

	var $FixedHeader = null,
		FixedHeaderHeight = null,
		ScrollYPosition = 0;

	function initPage() {
		// If you want a fixed header, set $FixedHeader to the DOM element
		$FixedHeader = $("#header");

		$(".js-toggle").not(".js-bound")
		               .on("click", ".js-toggle-handle", onToggleClick)
		               .addClass("js-bound");

		$(".js-scroll-to").not(".js-bound")
		                  .on("click", onScrollTo)
		                  .addClass("js-bound");

		// Fix IE SVG references to target an embedded <svg> tag in the DOM rather than externally referenced IDs
		var ua = window.navigator.userAgent,
		    msie = ua.indexOf("MSIE ");

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
			// IE11 Compat mode, see function icon()
			$.get(ICONS_SVG_URL, function(data) {
				var $div = $("<div>").hide()
				                     .html(new XMLSerializer().serializeToString(data.documentElement))
				                     .appendTo("body");

				$("svg use").each(function() {
					var parts = $(this).attr("xlink:href").split("#");

					$(this).attr("xlink:href", "#" + parts[1]);
				});
			});
		}

		// Wrap iframe videos for responsiveness
		$("iframe[src*='vimeo.com'], iframe[src*='youtube.com']", ".typography").each(function() {
			$(this).wrap('<div class="video_frame"></div>');
		});

		// Wrap tables for responsive tables
		$(".typography table").wrap('<div class="table_wrapper"><div class="table_wrapper_inner"></div></div>');

		// Set active state of search areas when typing in their inputs
		$(".js-site-search-input").on("input", function() {
			if ($(this).val()) {
				$(this).closest(".js-site-search").addClass("active");
			} else {
				$(this).closest(".js-site-search").removeClass("active");
			}
		});

		$(window).on("resize.page", tableOverflow);
		$(window).on("resize.page", recalculateFixedHeaderHeight);
		onPageLoad();
	}


	function onPageLoad() {
		$("body").removeClass("preload").addClass("loaded");

		// TODO: Why?
		//$(window).trigger("resize");

		// Checks to see if URL has deep link to #quicklinks, and loads the "For You" menu.
		if (window.location.hash == "#quicklinks") {
			$(".audience_toggle").swap('activate');

		} else if (window.location.hash) {
			// ?? deep link to an element
			scrollToElement(window.location.hash);
		}
	}

	function onScrollTo(e) {
		killEvent(e);

		scrollToElement($(e.delegateTarget).attr("href"));
	}

	function onToggleClick(e) {
		killEvent(e);

		$(e.delegateTarget).toggleClass("js-toggle-active");
	}

	function recalculateFixedHeaderHeight() {
		var wp_bar_height;
		var window_width;
		var header_logo_height;
		var header_ribbon_height;

		fastdom.measure(function () {
			wp_bar_height = $("#wpadminbar").outerHeight();
			window_width = $(window).width();
			header_logo_height = $(".js-header-logo").outerHeight();
			header_ribbon_height = $("#header .header_ribbon").outerHeight()
			if (window_width < 980) {
				FixedHeaderHeight = header_logo_height + 10;
			} else {
				FixedHeaderHeight = header_ribbon_height + header_logo_height + 10;
			}
			if (wp_bar_height) {
				FixedHeaderHeight = FixedHeaderHeight + wp_bar_height;
			}
		});

		fastdom.mutate(function () {
			if (wp_bar_height) {
				$FixedHeader.css("top", wp_bar_height);
			}
		});
	}

	function scrollToElement(id) {
		var offset = $(id).offset();

		if (typeof offset !== "undefined") {
			scrollToPosition(offset.top);
		}
	}

	function scrollToPosition(top) {
		if ($FixedHeader && !FixedHeaderHeight) {
			recalculateFixedHeaderHeight();
		}

		$("html, body").animate({
			scrollTop: top - FixedHeaderHeight
		});
	}

	function tableOverflow() {
		var addOverflow = [];
		var removeOverflow = [];

		fastdom.measure(function () {
			$(".table_wrapper").each(function() {
				var $inner = $(this).find(".table_wrapper_inner"),
					scrollWidth = $inner.get(0).scrollWidth,
					clientWidth = $inner.get(0).clientWidth;
	
				if (scrollWidth > clientWidth) {
					addOverflow.push(this);
				} else {
					removeOverflow.push(this);
				}
			});
		});

		fastdom.mutate(function () {
			var i;
			for (i = 0; i < addOverflow.length; i++) {
				$(addOverflow[i])
					.addClass("table_wrapper_overflow")
					.attr({ "tabindex": "0", "role": "group" });
			}
			for (i = 0; i < removeOverflow.length; i++) {
				$(removeOverflow[i])
					.removeClass("table_wrapper_overflow")
					.removeAttr("tabindex role");
			}
		});
	}

	export function saveScrollYPosition() {
		ScrollYPosition = window.pageYOffset;

		$(".page_wrapper").css({
			"width": "100%",
			"position": "fixed",
			"top": (ScrollYPosition * -1)
		});
	}

	export function restoreScrollYPosition() {
		$(".page_wrapper").css({
			"width": "",
			"position": "",
			"top": ""
		});

		$("html, body").scrollTop(ScrollYPosition);
	}

	export function getScrollbarWidth() {
		var $outer = $("<div>").css({
			"visibility": "hidden",
			"width": "100px",
			"msOverflowStyle": "scrollbar"
		}).appendTo("body");

		var no_scroll_width = $outer.outerWidth();

		// force scrollbars
		$outer.css({ "overflow": "scroll" });

		// add inner div and calculate width difference
		var $inner = $("<div>").css({ "width": "100%" }).appendTo($outer);
		var width = no_scroll_width - $inner.outerWidth();

		// remove divs
		$outer.remove();

		return width;
	}

	export var Namespace = "framework";
	export var MinXS = 320;
	export var MinSM = 500;
	export var MinMD = 740;
	export var MinLG = 980;
	export var MinXL = 1220;
	export var MinXXL = 1330;
	export var IsIE = calcIsIE();
	export var largeModeQuery = matchMedia("(min-width: " + MinLG + "px)");

	function calcIsIE() {
		var ua = window.navigator.userAgent;
		return ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./);
	}

	// Returns icon markup
	export function icon(icon) {
		var markup = '<svg class="icon icon_' + icon + '">';

		if (IsIE) {
			// IE11 compat. page.js inject SVG into document
			markup += '<use xlink:href="#' + icon + '">';
		} else {
			markup += '<use xlink:href="' + ICONS_SVG_URL + '#' + icon + '">';
		}

		return markup + '</use></svg>';
	}

	export function killEvent(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
			e.stopPropagation();
		}
	}

	/**
	 * Listens when page size changes between mobile and
	 * desktop modes.
	 * 
	 * @param {function(event)} callback 
	 */
	export function addLargeListener(callback) {
		if (largeModeQuery.addEventListener) {
			largeModeQuery.addEventListener('change', callback);
		} else {
			// For IE 11 and Safari 13 and earlier support
			largeModeQuery.addListener(callback);
		}
		callback({"matches": largeModeQuery.matches});
	}

	$(initPage);
